/**
 * Constants for ActionPlan module
 */

import { ActionPlanFilters } from './types';

export const DEFAULT_FILTERS: ActionPlanFilters = {
  source: 'All',
  type: 'All',
  assignedUser: 'All',
  status: 'All',
  priority: 'All',
  startDate: '',
  targetDate: '',
  actionPlanOwner: 'All',
  sort_by: 'created_at',
  sort_order: 'DESC',
  location: '',
  pageNumber: 1,
  pageSize: 10,
};

/**
 * Filter debounce delay (milliseconds)
 */
export const FILTER_DEBOUNCE_DELAY = 500;

/**
 * Source value for Action Plans generated from a People Coaching item. Excluded from the
 * default dashboard view (table + calendar); the user opts in via the Source filter.
 */
export const PEOPLE_COACHING_SOURCE = 'People_Coaching';

/**
 * Status mapping from display format to API format
 */
export const STATUS_DISPLAY_TO_API: Record<string, string> = {
  'completed': 'completed',
  'in progress': 'in_progress',
  'in_progress': 'in_progress',
  'declined': 'declined',
  'overdue': 'overdue',
};

/**
 * Default user ID for status updates (should be replaced with actual user context)
 */
export const DEFAULT_USER_ID = '44444444';

/**
 * Color mappings for action plan priority and status
 */
export const COLOR_MAPPING = {
  DEFAULT: '#005CBC',
  COMPLETED: '#4caf50',
  HIGH_PRIORITY: '#ff6b6b',
  MEDIUM_PRIORITY: '#ffc107',
};

/**
 * Tab types for dashboard
 */
export type TabType = 'Hybrid' | 'Table' | 'Calendar';

/**
 * Mock data for previewing the CreateNewActionPlan form in development
 */
export const MOCK_ACTION_PLAN_DATA = {
  title: 'Improve loading bay safety',
  source: { id: 'inspection', displayText: 'Inspection' },
  type: { id: 'process', displayText: 'Process' },
  priority: { id: 'high', displayText: 'High' },
  owner: { id: 'aishwarya', displayText: 'Aishwarya Thiyagarajan' },
  assignee: { id: 'haripriya', displayText: 'Haripriya Bandaru' },
  startDate: new Date('2025-11-10'),
  targetDate: new Date('2025-12-15'),
  actionPlan:
    'Re-train staff on proper pallet stacking and securement. Add new signage at the loading zone and schedule a follow-up inspection.',
  notes: 'Key risk observed during night shift. Temporary tape markings applied.',
  frontlineInvolvement: true,
  employee: { id: 'emp_b', displayText: 'Bob Martin' },
};

/**
 * Form configuration constants for CreateNewActionPlan
 */
export const FORM_DEFAULTS = {
  TYPE: 'create',
  INITIAL_DATA: {},
};
